import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/bugsnag/bugsnag.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { BugsnagService } from '@ng/core/bugsnag/bugsnag.service';
export type { B2BFeatureFlags } from '@ng/core/bugsnag/bugsnag.service';

export const BugsnagServiceModule = angular.module('acme.common.service.bugsnag', []).name;
